import * as React from "react";
import { FormattedMessage } from "react-intl";

import { getCookie, setCookie } from "../../helpers";

import "./styles.css";

export interface ICookieAlertState {
  accepted: boolean;
}

class CookieAlert extends React.Component<{}, ICookieAlertState> {
  constructor(props: any) {
    super(props);

    this.state = { accepted: getCookie("cookie-accepted") === "yes" };
    this.handleAcceptCookieButton = this.handleAcceptCookieButton.bind(this);
  }

  public handleAcceptCookieButton() {
    setCookie("cookie-accepted", "yes", 366);
    this.setState({ accepted: true });
  }

  public render() {
    return (
      !this.state.accepted && (
        <div className="psg-cookie">
          <div>
            <div className="psg-cookie__cookieLabel">
              <FormattedMessage
                id="cookie-alert.caution"
                defaultMessage="We use session cookies to collect session ID and authentication data. The cookies expire when you close your browser session. We also use persistent anonymous cookies to remember functional preferences, such as language settings."
              />
            </div>
            <div>
              <button className="psg-cookie__button" type="button" onClick={this.handleAcceptCookieButton}>
                <FormattedMessage id="cookie-alert.button" defaultMessage="Agree" />
              </button>
            </div>
          </div>
        </div>
      )
    );
  }
}

export default CookieAlert;



// WEBPACK FOOTER //
// ./src/components/cookie-alert/index.tsx